<mbs-modal
  [title]="'shared:reserveAuth.termsModalTitle' | i18next"
  [isCustomModal]="true"
  [titleTextOverflow]="true"
  #modal>
  <div modal-body>
    <ul>
      <li class="mb-2">{{ 'shared:reserveAuth.termsListItem1' | i18next }}</li>
      <li class="mb-2">{{ 'shared:reserveAuth.termsListItem2' | i18next }}</li>
      <li class="mb-2">{{ 'shared:reserveAuth.termsListItem3' | i18next }}</li>
      <li>
        {{ 'shared:reserveAuth.termsListItem4' | i18next }}

        <ul class="">
          <li class="my-1">
            <a
              href="https://www.msp360.com/company/legal/privacy-policy"
              target="_blank"
              >{{ 'shared:reserveAuth.privacyPolicy' | i18next }}</a
            >
          </li>
          <li>
            <a
              href="https://www.msp360.com/company/legal/terms-and-conditions"
              target="_blank"
              >{{ 'shared:reserveAuth.termsOfService' | i18next }}</a
            >
          </li>
        </ul>
      </li>
    </ul>

    <mbs-form-group>
      <mbs-checkbox
        [label]="'shared:reserveAuth.termsAgreementCheckbox' | i18next"
        [formControl]="agreementControl"></mbs-checkbox>
    </mbs-form-group>
  </div>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="!agreementControl.value"
      (click)="modal.save()">
      {{ 'shared:buttons.proceed' | i18next }}
    </mbs-button>

    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
